// extracted by mini-css-extract-plugin
export var body = "BlogPost-module--body--31feb";
export var date = "BlogPost-module--date--09a86";
export var excerpt = "BlogPost-module--excerpt--3eae7";
export var extract = "BlogPost-module--extract--18722";
export var featuredImage = "BlogPost-module--featuredImage--ddd47";
export var relatedContent = "BlogPost-module--relatedContent--af486";
export var relatedContentWrapper = "BlogPost-module--relatedContentWrapper--7d995";
export var tableContents = "BlogPost-module--tableContents--f069b";
export var tableContentsWrapper = "BlogPost-module--tableContentsWrapper--e8fba";
export var title = "BlogPost-module--title--f1e46";
export var wordsmith = "BlogPost-module--wordsmith--43e26";
export var wrapper = "BlogPost-module--wrapper--26d91";